// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Audit extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  auditId!: number;
  application!: string;
  auditDate!: Date;
  columnName?: string;
  hostName!: string;
  newValue?: string;
  oldValue?: string;
  operation!: string;
  primaryKey!: string;
  rowDescription?: string;
  rowVersion?: number;
  sQLStatement?: string;
  secondaryRow?: string;
  sysUser!: string;
  tableName!: string;
}

